import { FC } from 'react';

import Heading from '../../ui/heading/Heading';

import styles from './404.module.sass';

const Error404: FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.error}>
        <Heading title="404 - Page Not Found" />{' '}
      </div>
    </div>
  );
};

export default Error404;